import { render } from "./SurveyList.vue?vue&type=template&id=0a577c44"
import script from "./SurveyList.vue?vue&type=script&lang=ts"
export * from "./SurveyList.vue?vue&type=script&lang=ts"
script.render = render

export default script